import { render, staticRenderFns } from "./level.vue?vue&type=template&id=56119e22&scoped=true&"
import script from "./level.vue?vue&type=script&lang=js&"
export * from "./level.vue?vue&type=script&lang=js&"
import style0 from "./level.vue?vue&type=style&index=0&id=56119e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56119e22",
  null
  
)

export default component.exports